import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import CONFIG from '../config'
import { AuthenticationService } from './authentication.service'
import { Platform } from '@ionic/angular';
import { HTTP } from '@ionic-native/http/ngx'
import { from } from 'rxjs';
import enviarToken from '../iterceptorNative';

@Injectable({
  providedIn: 'root'
})
export class NoticacionesService {
  constructor(public httpNative: HTTP, public http: HttpClient, public platform: Platform) { }
  notBitacora(datos) {
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.post(CONFIG.API + '/api/notificaciones/bitacora', datos, enviarToken())
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            console.log(err);
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        this.http.post(CONFIG.API + '/api/notificaciones/bitacora', datos)
          .subscribe((reporte: any) => {
            resolve(reporte)
          }, (err) => {
            console.log(err)
            reject(err)
          })
      })
    }
  }
  envioNot(datos) {
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.post(CONFIG.API + '/api/notificaciones/', datos, enviarToken())
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            console.log(err);
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        this.http.post(CONFIG.API + '/api/notificaciones/', datos)
          .subscribe((reporte: any) => {
            resolve(reporte)
          }, (err) => {
            console.log(err)
            reject(err)
          })
      })
    }
  }

  obtenerMensajesBit() {
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.get(CONFIG.API + '/api/notificaciones/mensajesBit', {}, enviarToken())
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            console.log(err);
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        this.http.get(CONFIG.API + '/api/notificaciones/mensajesBit')
          .subscribe((usuarios: any) => {
            resolve(usuarios)
          }, (err) => {
            console.log(err)
            reject(err)
          })
      })
    }

  }

  notificacionInspeccion(datos) {
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.post(CONFIG.API + '/api/notificaciones/inspeccion', datos, enviarToken())
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            console.log(err);
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        this.http.post(CONFIG.API + '/api/notificaciones/inspeccion', datos)
          .subscribe((reporte: any) => {
            resolve(reporte)
          }, (err) => {
            console.log(err)
            reject(err)
          })
      })
    }
  }

  reenviarBitacora(id) {
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.post(CONFIG.API + '/api/notificaciones/reenvioBitacora/'+id, {}, enviarToken())
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            console.log(err);
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        this.http.get(CONFIG.API + '/api/notificaciones/reenvioBitacora/'+id)
          .subscribe((reporte: any) => {
            resolve(reporte)
          }, (err) => {
            console.log(err)
            reject(err)
          })
      })
    }
  }

  notificacionMensaje(datos) {
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.post(CONFIG.API + '/api/notificaciones/Mensajeinspeccion/', datos, enviarToken())
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            console.log(err);
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        this.http.post(CONFIG.API + '/api/notificaciones/Mensajeinspeccion/',datos)
          .subscribe((usuarios: any) => {
            resolve(usuarios)
          }, (err) => {
            console.log(err)
            reject(err)
          })
      })
    }

  }
  
}
